import { OperationActions, OperationTypes } from "../../consts/OperationTypes";

export interface IOperationState {
  archivosSubidos: File[],
  isUploading: boolean
}

const initialState : IOperationState = {archivosSubidos: [], isUploading: false};

export default function (state = initialState, action : OperationActions) {
  switch (action.type) {
    case OperationTypes.START:
      return { ...state };
    case OperationTypes.SUCCESS:
      return { ...state, prestador: action.payload.prestador, valorEncriptado: action.payload.valorEncriptado };
    case OperationTypes.ERROR:
      return { ...state, prestador: null };
    case OperationTypes.CARGAR_ARCHIVOS_START:
      return { ...state, isUploading: true };
    case OperationTypes.CARGAR_ARCHIVOS_SUCCESS:
      return { ...state, isUploading: false, archivosSubidos:[...state.archivosSubidos, ...action.payload.archivosSubidos] };
    case OperationTypes.CARGAR_ARCHIVOS_ERROR:
      return { ...state, isUploading: false, error: action.payload.error };
    default:
      return { ...state };
  }
}
